import FormComponent from './FormComponent';
import EmailInputFieldComponent from './EmailInputFieldComponent';
import TextInputFieldComponent from './TextInputFieldComponent';
import PasswordInputFieldComponent from './PasswordInputFieldComponent';
import DateInputFieldComponent from './DateInputFieldComponent';
import NumberInputFieldComponent from './NumberInputFieldComponent';
import PhoneInputFieldComponent from './PhoneInputFieldComponent';
import CheckboxInputFieldComponent from './boxInput/CheckboxInputFieldComponent';
import RadioInputFieldComponent from './boxInput/RadioInputFieldComponent';
import SelectFieldComponent from './SelectFieldComponent';
import TextareaFieldComponent from './TextareaFieldComponent';
import FilesInputFieldComponent from './fileInput/FilesInputFieldComponent';
import LegendFieldComponent from './LegendFieldComponent';
import IBANInputFieldComponent from './IBANInputFieldComponent';
import BICInputFieldComponent from './BICInputFieldComponent';
import HourInputFieldComponent from './HourInputFieldComponent';

export {
    FormComponent,
    EmailInputFieldComponent,
    TextInputFieldComponent,
    PasswordInputFieldComponent,
    DateInputFieldComponent,
    NumberInputFieldComponent,
    PhoneInputFieldComponent,
    CheckboxInputFieldComponent,
    RadioInputFieldComponent,
    SelectFieldComponent,
    TextareaFieldComponent,
    FilesInputFieldComponent,
    LegendFieldComponent,
    IBANInputFieldComponent,
    BICInputFieldComponent,
    HourInputFieldComponent
};



// WEBPACK FOOTER //
// ./src/components/form/index.js